// import React, { useState, useEffect, useRef } from "react";
// import "./iqcmFormView.css";
// import { useParams } from "react-router-dom";
// import API_URL from "../../src/Config";
// import axios from "axios";
// import { MdAttachFile } from "react-icons/md";
// import { MdDeleteOutline } from "react-icons/md";
// import { FiUpload } from "react-icons/fi";
// import { IoCloseOutline } from "react-icons/io5";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import { FiArrowLeft } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import { FiInfo } from "react-icons/fi";
// import { FaPlusCircle } from "react-icons/fa";

// const IqcmFormView = ({ isSidebarExpanded }) => {
//   const { formId } = useParams();
//   const [form, setForm] = useState(null);
//   const [currentSection, setCurrentSection] = useState(0);
//   const [responses, setResponses] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [allResponseData, setAllResponseData] = useState(null);
//   const [progress, setProgress] = useState(null);
//   const [deleteConfirmation, setDeleteConfirmation] = useState({
//     isOpen: false,
//     itemId: null,
//     attachmentId: null,
//     attachmentName: "",
//   });
//   const [gotoValue, setGotoValue] = useState("");
//   const fileInputRefs = useRef({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (formId) {
//       fetchFormData(formId);
//     }
//   }, [formId]);

//   const fetchFormData = async (formId) => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       setLoading(true);
//       setError(null);

//       let response;
//       try {
//         response = await axios.get(
//           `${API_URL}/api/qc/forms/${formId}/responses`,
//           {
//             headers: {
//               Authorization: authKey,
//             },
//           }
//         );
//       } catch (responseError) {
//         console.log("Falling back to basic form endpoint");
//         response = await axios.get(`${API_URL}/api/qc/forms/${formId}`, {
//           headers: {
//             Authorization: authKey,
//           },
//         });
//       }

//       const { form, sections, progress } = response.data;
//       setAllResponseData(response.data);
//       setProgress(progress);

//       // Build initial responses state with document structure
//       const existingResponses = {};
//       if (Array.isArray(sections)) {
//         sections.forEach((section) => {
//           if (Array.isArray(section.items)) {
//             section.items.forEach((item) => {
//               const itemId = item.id || item.item_id;
//               const ans = item.answer || {};

//               existingResponses[itemId] = {
//                 status: ans.rating || "NYS",
//                 remarks: ans.remarks || "",
//                 inspector: ans.inspector || "",
//                 documents: [], // New structure for named documents
//                 existingAttachments: ans.attachments || [],
//                 popupOpen: false,
//               };
//             });
//           }
//         });
//       }

//       setForm({ ...form, sections });
//       console.log("form", sections);
//       setResponses(existingResponses);
//     } catch (error) {
//       console.error("Error fetching form data:", error.message);
//       setError("Failed to load form data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Document management functions
//   const addDocument = (itemId) => {
//     setResponses((prev) => {
//       const currentDocs = prev[itemId]?.documents || [];
//       const existingAttachments = prev[itemId]?.existingAttachments || [];
//       const totalAttachments = currentDocs.length + existingAttachments.length;

//       if (totalAttachments >= 3) return prev; // Max 3 documents total

//       return {
//         ...prev,
//         [itemId]: {
//           ...(prev[itemId] || {}),
//           documents: [
//             ...currentDocs,
//             { name: "", file: null, fileDetails: null, id: Date.now() },
//           ],
//         },
//       };
//     });
//   };

//   const removeDocument = (itemId, docId) => {
//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: {
//         ...(prev[itemId] || {}),
//         documents:
//           prev[itemId]?.documents?.filter((doc) => doc.id !== docId) || [],
//       },
//     }));
//   };

//   const updateDocumentName = (itemId, docId, name) => {
//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: {
//         ...(prev[itemId] || {}),
//         documents:
//           prev[itemId]?.documents?.map((doc) =>
//             doc.id === docId ? { ...doc, name: name.slice(0, 255) } : doc
//           ) || [],
//       },
//     }));
//   };

//   const updateDocumentFile = (itemId, docId, file) => {
//     if (!file) return;

//     const fileDetails = {
//       name: file.name,
//       size: file.size,
//     };

//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: {
//         ...(prev[itemId] || {}),
//         documents:
//           prev[itemId]?.documents?.map((doc) =>
//             doc.id === docId ? { ...doc, file, fileDetails } : doc
//           ) || [],
//       },
//     }));
//   };

//   const handleRadioChange = (itemId, value) => {
//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: { ...(prev[itemId] || {}), status: value },
//     }));
//   };

//   const handleRemarksChange = (itemId, value) => {
//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: { ...(prev[itemId] || {}), remarks: value },
//     }));
//   };

//   const handleInspectorChange = (itemId, value) => {
//     setResponses((prev) => ({
//       ...prev,
//       [itemId]: { ...(prev[itemId] || {}), inspector: value },
//     }));
//   };

//   const previousSection = () => {
//     if (currentSection > 0) {
//       setCurrentSection((prev) => prev - 1);
//     }
//   };

//   const goToNextSection = () => {
//     if (currentSection < form.sections.length - 1) {
//       setCurrentSection((prev) => prev + 1);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   };

//   const goToSection = () => {
//     if (!gotoValue.trim()) return;

//     let val = gotoValue.trim();

//     // Option A: take integer part only
//     let sectionNum = parseInt(val.split(".")[0]);

//     if (!sectionNum || sectionNum < 1 || sectionNum > form.sections.length) {
//       setSeverity("error");
//       setSnackbarMessage("Invalid section number.");
//       setSnackbarOpen(true);
//       return;
//     }

//     setCurrentSection(sectionNum - 1);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const isLastSection = () => {
//     return currentSection === form.sections.length - 1;
//   };

//   const handleUploadButtonClick = (itemId, docId) => {
//     const fileInput = document.getElementById(`file-input-${itemId}-${docId}`);
//     if (fileInput) {
//       fileInput.click();
//     }
//   };

//   const handleFileInputChange = (itemId, docId, e) => {
//     const file = e.target.files[0];
//     if (file) {
//       updateDocumentFile(itemId, docId, file);
//     }
//     e.target.value = ""; // Allow reselect
//   };

//   const handleDeleteFile = async (
//     itemId,
//     attachmentId = null,
//     attachmentName = ""
//   ) => {
//     if (attachmentId) {
//       // Show confirmation popup for existing attachments
//       setDeleteConfirmation({
//         isOpen: true,
//         itemId,
//         attachmentId,
//         attachmentName,
//       });
//     } else {
//       // Direct delete for local files
//       setSnackbarMessage("Local file removed");
//       setSeverity("success");
//       setSnackbarOpen(true);
//       setTimeout(() => {
//         setSnackbarOpen(false);
//       }, 3000);
//     }
//   };

//   const confirmDelete = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const { itemId, attachmentId } = deleteConfirmation;

//       const response = await axios.delete(
//         `${API_URL}/api/qc/attachments/${attachmentId}`,
//         {
//           headers: {
//             Authorization: authKey,
//           },
//         }
//       );

//       if (response.status === 200) {
//         setSeverity("success");
//         setSnackbarMessage("Attachment deleted successfully");
//         setSnackbarOpen(true);
//         await fetchFormData(formId);
//       }
//     } catch (error) {
//       console.error("Error deleting attachment:", error);
//       setSeverity("error");
//       setSnackbarMessage("Failed to delete attachment");
//       setSnackbarOpen(true);
//     }

//     setDeleteConfirmation({
//       isOpen: false,
//       itemId: null,
//       attachmentId: null,
//       attachmentName: "",
//     });

//     setTimeout(() => {
//       setSnackbarOpen(false);
//     }, 3000);
//   };

//   const cancelDelete = () => {
//     setDeleteConfirmation({
//       isOpen: false,
//       itemId: null,
//       attachmentId: null,
//       attachmentName: "",
//     });
//   };

//   const handleDownloadAttachment = (attachmentId, filename) => {
//     const authKey = localStorage.getItem("authKey");
//     const downloadUrl = `${API_URL}/api/qc/attachments/${attachmentId}/download`;

//     fetch(downloadUrl, {
//       method: "GET",
//       headers: {
//         Authorization: authKey,
//       },
//     })
//       .then((response) => response.blob())
//       .then((blob) => {
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", filename);
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//         window.URL.revokeObjectURL(url);
//       })
//       .catch((error) => {
//         console.error("Download failed:", error);
//         setSeverity("error");
//         setSnackbarMessage("Failed to download attachment");
//         setSnackbarOpen(true);
//       });
//   };

//   const handleViewAttachment = (attachmentId) => {
//     const authKey = localStorage.getItem("authKey");
//     const viewUrl = `${API_URL}/api/qc/attachments/${attachmentId}/view`;
//     const newWindow = window.open("", "_blank");

//     fetch(viewUrl, {
//       method: "GET",
//       headers: {
//         Authorization: authKey,
//       },
//     })
//       .then((response) => {
//         if (response.ok) {
//           return response.blob();
//         }
//         throw new Error("Failed to load file");
//       })
//       .then((blob) => {
//         const url = window.URL.createObjectURL(blob);
//         newWindow.location.href = url;
//       })
//       .catch((error) => {
//         console.error("View failed:", error);
//         newWindow.close();
//         setSeverity("error");
//         setSnackbarMessage("Failed to view attachment");
//         setSnackbarOpen(true);
//       });
//   };

//   const handleSaveCurrentSection = async () => {
//     const section = form.sections[currentSection];
//     if (!section?.items) return;

//     const sectionResponses = [];
//     const formData = new FormData();

//     section.items.forEach((item) => {
//       const itemId = item.id || item.item_id;
//       const itemData = responses[itemId];

//       if (itemData?.status) {
//         sectionResponses.push({
//           item_id: itemId,
//           rating: itemData.status,
//           remarks: itemData.remarks || "",
//           inspector: itemData.inspector || "",
//         });

//         // Handle multiple named documents
//         if (itemData.documents && itemData.documents.length > 0) {
//           itemData.documents.forEach((doc, index) => {
//             if (doc.file && doc.name.trim()) {
//               formData.append(
//                 `docs_${itemId}[${index}][name]`,
//                 doc.name.trim()
//               );
//               formData.append(`docs_${itemId}[${index}][file]`, doc.file);
//             }
//           });
//         }
//       }
//     });

//     if (sectionResponses.length === 0) {
//       alert("Please fill at least one item before saving this section.");
//       return;
//     }

//     // Check for documents without names
//     const hasInvalidDocs = sectionResponses.some((resp) => {
//       const itemData = responses[resp.item_id];
//       return itemData.documents?.some((doc) => doc.file && !doc.name.trim());
//     });

//     if (hasInvalidDocs) {
//       setSeverity("error");
//       setSnackbarMessage("Please provide names for all uploaded documents");
//       setSnackbarOpen(true);
//       return;
//     }

//     formData.append("responses", JSON.stringify(sectionResponses));

//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await fetch(
//         `${API_URL}/api/qc/forms/${formId}/submit-batch`,
//         {
//           method: "POST",
//           headers: { Authorization: authKey },
//           body: formData,
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.error || `HTTP ${response.status}`);
//       }

//       setSeverity("success");
//       setSnackbarMessage("Section saved successfully");
//       setSnackbarOpen(true);

//       setTimeout(() => {
//         setSnackbarOpen(false);
//       }, 2500);

//       setTimeout(async () => {
//         await fetchFormData(formId);
//         if (currentSection < form.sections.length - 1) {
//           setCurrentSection((prev) => prev + 1);
//         }
//       }, 1500);
//     } catch (err) {
//       console.error("Error saving section:", err);
//       setSeverity("error");
//       setSnackbarMessage(`Failed to save section: ${err.message}`);
//       setSnackbarOpen(true);
//     }
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const clickOnBackBtn = () => {
//     navigate("/iqcm-form-list");
//   };

//   // Helper function to render attachments section
//   const renderAttachmentsSection = (item, itemResponse) => {
//     const itemId = item.id || item.item_id;
//     const existingAttachments = itemResponse.existingAttachments || [];
//     const documents = itemResponse.documents || [];
//     const totalAttachments = existingAttachments.length + documents.length;

//     return (
//       <div className="field">
//         <label className="field-label">Attachments</label>

//         {/* Attachment Guidelines */}
//         <div className="attachment-guidelines">
//           <div className="guidelines-content">
//             <span className="guidelines-text">
//               Maximum 3 files allowed • Maximum file size: 5 MB per file
//             </span>
//             <span className="supported-formats">
//               Supported formats: Images, PDF, DOC, DOCX
//             </span>
//           </div>
//         </div>

//         {/* Existing attachments */}
//         {existingAttachments.map((attachment) => {
//           if (attachment.popupOpen === undefined) attachment.popupOpen = false;

//           return (
//             <div key={attachment.id} className="existing-attachment-row">
//               <div className="attachment-content">
//                 <input
//                   type="text"
//                   value={attachment.doc_name || ""}
//                   placeholder="Document name"
//                   readOnly
//                   className="attachment-name-input"
//                 />
//                 <div className="attachment-actions">
//                   <button
//                     type="button"
//                     className="attachment-open-btn"
//                     onClick={() =>
//                       setResponses((prev) => ({
//                         ...prev,
//                         [itemId]: {
//                           ...(prev[itemId] || {}),
//                           existingAttachments: prev[
//                             itemId
//                           ]?.existingAttachments.map((att) =>
//                             att.id === attachment.id
//                               ? { ...att, popupOpen: !att.popupOpen }
//                               : att
//                           ),
//                         },
//                       }))
//                     }
//                   >
//                     <MdAttachFile />
//                   </button>
//                 </div>
//               </div>

//               {/* Popup for existing attachments */}
//               {attachment.popupOpen && (
//                 <div className="attachment-popup-backdrop">
//                   <div className="attachment-popup">
//                     <div className="attachment-popup-content">
//                       <div className="attachment-popup-header">
//                         <div className="attachment-popup-title">
//                           {attachment.doc_name || "Attachment"}
//                         </div>
//                         <button
//                           className="popup-close-btn"
//                           onClick={() =>
//                             setResponses((prev) => ({
//                               ...prev,
//                               [itemId]: {
//                                 ...(prev[itemId] || {}),
//                                 existingAttachments: prev[
//                                   itemId
//                                 ]?.existingAttachments.map((att) =>
//                                   att.id === attachment.id
//                                     ? { ...att, popupOpen: false }
//                                     : att
//                                 ),
//                               },
//                             }))
//                           }
//                         >
//                           <IoCloseOutline />
//                         </button>
//                       </div>
//                       <div className="attachment-popup-body">
//                         <div className="attachment-file-info">
//                           <div className="file-info-row">
//                             <strong>File Name:</strong> {attachment.filename}
//                           </div>
//                           <div className="file-info-row">
//                             <strong>Size:</strong>{" "}
//                             {(attachment.file_size / 1024).toFixed(2)} KB
//                           </div>
//                         </div>
//                         <div className="attachment-popup-actions">
//                           <button
//                             onClick={() =>
//                               handleDownloadAttachment(
//                                 attachment.id,
//                                 attachment.filename
//                               )
//                             }
//                             className="popup-action-btn download-btn"
//                           >
//                             Download
//                           </button>
//                           <button
//                             onClick={() => handleViewAttachment(attachment.id)}
//                             className="popup-action-btn view-btn"
//                           >
//                             View
//                           </button>
//                           <button
//                             className="popup-action-btn delete-btn"
//                             onClick={() =>
//                               handleDeleteFile(
//                                 itemId,
//                                 attachment.id,
//                                 attachment.doc_name || attachment.filename
//                               )
//                             }
//                           >
//                             <MdDeleteOutline />
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* New documents */}
//         {documents.map((doc, index) => {
//           if (doc.popupOpen === undefined) doc.popupOpen = false;
//           const hasFile = !!doc.fileDetails;

//           return (
//             <div key={doc.id} className="new-attachment-row">
//               <div className="new-attachment-content">
//                 <input
//                   type="text"
//                   value={doc.name}
//                   placeholder={`Document ${index + 1} name *`}
//                   onChange={(e) =>
//                     updateDocumentName(itemId, doc.id, e.target.value)
//                   }
//                   className="attachment-name-input"
//                   maxLength={255}
//                   required={!!doc.file}
//                 />

//                 <div className="new-attachment-actions">
//                   <button
//                     type="button"
//                     onClick={() => handleUploadButtonClick(itemId, doc.id)}
//                     className="upload-file-btn"
//                   >
//                     <FiUpload /> Choose File
//                   </button>

//                   {hasFile && (
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setResponses((prev) => ({
//                           ...prev,
//                           [itemId]: {
//                             ...(prev[itemId] || {}),
//                             documents: prev[itemId]?.documents.map((d) =>
//                               d.id === doc.id
//                                 ? { ...d, popupOpen: !d.popupOpen }
//                                 : d
//                             ),
//                           },
//                         }))
//                       }
//                       className="attachment-open-btn"
//                     >
//                       <MdAttachFile />
//                     </button>
//                   )}

//                   <button
//                     type="button"
//                     onClick={() => removeDocument(itemId, doc.id)}
//                     className="remove-attachment-btn"
//                   >
//                     <MdDeleteOutline />
//                   </button>
//                 </div>
//               </div>

//               <input
//                 id={`file-input-${itemId}-${doc.id}`}
//                 type="file"
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileInputChange(itemId, doc.id, e)}
//                 accept="image/*,.pdf,.doc,.docx"
//               />

//               {/* Popup for new docs */}
//               {doc.popupOpen && hasFile && (
//                 <div className="attachment-popup-backdrop">
//                   <div className="attachment-popup">
//                     <div className="attachment-popup-content">
//                       <div className="attachment-popup-header">
//                         <div className="attachment-popup-title">
//                           {doc.name || "New Attachment"}
//                         </div>
//                         <button
//                           className="popup-close-btn"
//                           onClick={() =>
//                             setResponses((prev) => ({
//                               ...prev,
//                               [itemId]: {
//                                 ...(prev[itemId] || {}),
//                                 documents: prev[itemId]?.documents.map((d) =>
//                                   d.id === doc.id
//                                     ? { ...d, popupOpen: false }
//                                     : d
//                                 ),
//                               },
//                             }))
//                           }
//                         >
//                           <IoCloseOutline />
//                         </button>
//                       </div>
//                       <div className="attachment-popup-body">
//                         <div className="attachment-file-info">
//                           <div className="file-info-row">
//                             <strong>File Name:</strong> {doc.fileDetails.name}
//                           </div>
//                           <div className="file-info-row">
//                             <strong>Size:</strong>{" "}
//                             {(doc.fileDetails.size / 1024).toFixed(2)} KB
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* Add Document Button */}
//         <div className="add-attachment-section">
//           <button
//             type="button"
//             onClick={() => addDocument(itemId)}
//             disabled={totalAttachments >= 3}
//             className="add-attachment-btn"
//           >
//             <FaPlusCircle />
//             <span>Add Document</span>
//           </button>
//           <span className="attachment-counter">({totalAttachments}/3)</span>
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="iqcm-container">
//         <div className="loading">Loading form data...</div>
//       </div>
//     );
//   }

//   if (error && !form) {
//     return (
//       <div className="iqcm-container">
//         <div className="error-container">
//           <div className="error-text">{error}</div>
//           <button onClick={() => fetchFormData(formId)} className="retry-btn">
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!form || !form.sections || form.sections.length === 0) {
//     return (
//       <div className="iqcm-container">
//         <div className="no-data">No form data available.</div>
//       </div>
//     );
//   }

//   const currentSectionData = form.sections[currentSection];

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="form-wrapper">
//           {/* Form Header */}
//           <div className="form-header">
//             <button onClick={clickOnBackBtn} className="circle-back-btn">
//               <FiArrowLeft size={20} />
//             </button>
//             <h2 className="form-title">{form.name}</h2>
//             <div>
//               <p className="form-meta">Created at: {form.created_at}</p>
//               <p className="form-meta">
//                 Last updated at: {allResponseData?.last_updated_at}
//               </p>
//               <p className="form-meta">
//                 Progress: {progress.completed_sections}/
//                 {progress.total_sections} sections (
//                 {progress.completion_percentage.toFixed(1)}%)
//               </p>
//             </div>
//           </div>

//           {/* Section Title */}
//           <h3 className="section-title">
//             Section : {currentSectionData?.section_code}.{" "}
//             {currentSectionData.section_title}
//           </h3>

//           {/* Error Message */}
//           {error && <div className="error-message">{error}</div>}

//           {/* Items List */}
//           <div className="items-list">
//             {currentSectionData.items.map((item, index) => {
//               const itemId = item.id || item.item_id;
//               const itemResponse = responses[itemId] || {};

//               return (
//                 <div key={itemId} className="item-card">
//                   <span>
//                     <p className="item-prompt">
//                       <strong>{item.question_code} </strong>. {item.prompt}
//                     </p>
//                   </span>

//                   {/* Rating */}
//                   <div className="field">
//                     <div className="radio-group-wrapper">
//                       <div className="radio-group">
//                         {[
//                           { value: "NYS", label: "NYS" },
//                           { value: "FM", label: "FM" },
//                           { value: "PM", label: "PM" },
//                           { value: "NC", label: "NC" },
//                           { value: "NA", label: "NA" },
//                         ].map((option) => (
//                           <label key={option.value} className="radio-option">
//                             <input
//                               type="radio"
//                               name={`item-${itemId}`}
//                               value={option.value}
//                               checked={itemResponse.status === option.value}
//                               onChange={() =>
//                                 handleRadioChange(itemId, option.value)
//                               }
//                             />
//                             <span className="radio-text">{option.label}</span>
//                           </label>
//                         ))}
//                       </div>

//                       <div className="iqcm-info-icon">
//                         <FiInfo size={18} />
//                         <div className="iqcm-tooltip">
//                           <p>
//                             <strong>NYS</strong> – Not Yet Started
//                           </p>
//                           <p>
//                             <strong>FM</strong> – Fully Met
//                           </p>
//                           <p>
//                             <strong>PM</strong> – Partially Met
//                           </p>
//                           <p>
//                             <strong>NC</strong> – Not Complied
//                           </p>
//                           <p>
//                             <strong>NA</strong> – Not Applicable
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Remarks */}
//                   <div className="field">
//                     <label className="field-label">Remarks</label>
//                     <textarea
//                       value={itemResponse.remarks || ""}
//                       onChange={(e) =>
//                         handleRemarksChange(itemId, e.target.value)
//                       }
//                       className="textarea"
//                       placeholder="Add any remarks or observations"
//                       rows="2"
//                     />
//                   </div>

//                   {/* Attachments - Use the updated render function */}
//                   {renderAttachmentsSection(item, itemResponse)}
//                 </div>
//               );
//             })}
//           </div>

//           {/* Go To Section Pagination */}
//           {/* <div className="go-to-section-container">
//             <label className="go-to-section-label">Go to section:</label>
//             <input
//               type="number"
//               min={1}
//               max={form.sections.length}
//               className="go-to-section-input"
//               placeholder="Enter section no."
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") {
//                   const sectionNum = Number(e.target.value);
//                   if (sectionNum >= 1 && sectionNum <= form.sections.length) {
//                     setCurrentSection(sectionNum - 1);
//                     window.scrollTo({ top: 0, behavior: "smooth" });
//                   } else {
//                     setSeverity("error");
//                     setSnackbarMessage("Invalid section number.");
//                     setSnackbarOpen(true);
//                   }
//                 }
//               }}
//             />
//             <span className="total-sections-info">
//               of {form.sections.length}
//             </span>
//           </div> */}

//           {/* Navigation Buttons */}
//           <div className="navigation-container">
//             <div className="nav-buttons">
//               <div className="next_save_btn">
//                 <button
//                   type="button"
//                   onClick={previousSection}
//                   disabled={currentSection === 0}
//                   className="nav-btn data-form-cancel-button"
//                 >
//                   Previous
//                 </button>

//                 {/* <div className="go-to-section-container">
//                   <label className="go-to-section-label">Go to section:</label>

//                   <input
//                     type="text"
//                     value={gotoValue}
//                     onChange={(e) => setGotoValue(e.target.value)}
//                     className="go-to-section-input"
//                     placeholder="Ex: 5 or 5.1"
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         goToSection();
//                       }
//                     }}
//                   />

//                   <button className="go-to-btn" onClick={goToSection}>
//                     Go
//                   </button>

//                   <span className="total-sections-info">
//                     of {form.sections.length}
//                   </span>
//                 </div> */}
//               </div>

//               <div className="next_save_btn">
//                 {isLastSection() ? (
//                   <>
//                     <button
//                       type="button"
//                       onClick={goToNextSection}
//                       disabled={currentSection === form.sections.length - 1}
//                       className="nav-btn data-form-cancel-button"
//                     >
//                       Next
//                     </button>
//                     <button
//                       type="button"
//                       onClick={handleSaveCurrentSection}
//                       className="nav-btn next-btn data-form-save-button"
//                     >
//                       Save Final Section
//                     </button>
//                   </>
//                 ) : (
//                   <>
//                     <button
//                       type="button"
//                       onClick={goToNextSection}
//                       disabled={currentSection === form.sections.length - 1}
//                       className="nav-btn data-form-cancel-button"
//                     >
//                       Next
//                     </button>
//                     <button
//                       type="button"
//                       onClick={handleSaveCurrentSection}
//                       className="nav-btn next-btn data-form-save-button"
//                     >
//                       Save & Next
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Popup */}
//       {deleteConfirmation.isOpen && (
//         <div className="attachment-popup-backdrop">
//           <div className="delete-confirmation-popup">
//             <div className="delete-confirmation-content">
//               <div className="delete-confirmation-header">
//                 <div className="delete-confirmation-title">Confirm Delete</div>
//               </div>
//               <div className="delete-confirmation-body">
//                 <div className="delete-warning-icon"></div>
//                 <div className="delete-confirmation-text">
//                   ⚠️ Are you sure you want to permanently delete this
//                   attachment?
//                 </div>
//                 <div className="delete-file-name">
//                   "{deleteConfirmation.attachmentName}"
//                 </div>
//                 <div className="delete-warning-text">
//                   This action cannot be undone.
//                 </div>
//               </div>
//               <div className="delete-confirmation-actions">
//                 <button className="delete-cancel-btn" onClick={cancelDelete}>
//                   Cancel
//                 </button>
//                 <button className="delete-confirm-btn" onClick={confirmDelete}>
//                   Delete Permanently
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// };

// export default IqcmFormView;

import React, { useState, useEffect, useRef } from "react";
import "./iqcmFormView.css";
import { useParams } from "react-router-dom";
import API_URL from "../../src/Config";
import axios from "axios";
import { MdAttachFile } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { FiInfo } from "react-icons/fi";
import { FaPlusCircle } from "react-icons/fa";

const IqcmFormView = ({ isSidebarExpanded }) => {
  const { formId } = useParams();
  const [form, setForm] = useState(null);
  const [currentSection, setCurrentSection] = useState(0);
  const [responses, setResponses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [allResponseData, setAllResponseData] = useState(null);
  const [progress, setProgress] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    itemId: null,
    attachmentId: null,
    attachmentName: "",
  });
  const [gotoValue, setGotoValue] = useState("");
  const [availableYears, setAvailableYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const fileInputRefs = useRef({});
  const navigate = useNavigate();

  // Fetch available years on component mount
  useEffect(() => {
    fetchAvailableYears();
  }, []);

  // Fetch form data when formId or selectedYear changes
  useEffect(() => {
    if (formId && selectedYear !== null) {
      fetchFormData(formId);
    }
  }, [formId, selectedYear]);

  const fetchAvailableYears = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/qc/reports/available-years`,
        {
          headers: {
            Authorization: authKey,
          },
        },
      );

      const { available_years, current_year } = response.data;
      setAvailableYears(available_years);
      setCurrentYear(current_year);
      setSelectedYear(current_year); // Set default to current year
    } catch (error) {
      console.error("Error fetching available years:", error);
      // Set current year as fallback
      const fallbackYear = new Date().getFullYear();
      setAvailableYears([fallbackYear]);
      setCurrentYear(fallbackYear);
      setSelectedYear(fallbackYear);
    }
  };

  const fetchFormData = async (formId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      setLoading(true);
      setError(null);

      let response;
      try {
        response = await axios.get(
          `${API_URL}/api/qc/forms/${formId}/responses`,
          {
            headers: {
              Authorization: authKey,
            },
            params: {
              cycle_year: selectedYear,
            },
          },
        );
      } catch (responseError) {
        console.log("Falling back to basic form endpoint");
        response = await axios.get(`${API_URL}/api/qc/forms/${formId}`, {
          headers: {
            Authorization: authKey,
          },
        });
      }

      const { form, sections, progress } = response.data;
      setAllResponseData(response.data);
      setProgress(progress);

      // Build initial responses state with document structure
      const existingResponses = {};
      if (Array.isArray(sections)) {
        sections.forEach((section) => {
          if (Array.isArray(section.items)) {
            section.items.forEach((item) => {
              const itemId = item.id || item.item_id;
              const ans = item.answer || {};

              existingResponses[itemId] = {
                status: ans.rating || "NYS",
                remarks: ans.remarks || "",
                inspector: ans.inspector || "",
                documents: [], // New structure for named documents
                existingAttachments: ans.attachments || [],
                popupOpen: false,
              };
            });
          }
        });
      }

      setForm({ ...form, sections });
      console.log("form", sections);
      setResponses(existingResponses);
    } catch (error) {
      console.error("Error fetching form data:", error.message);
      setError("Failed to load form data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value);
    setSelectedYear(year);
    setCurrentSection(0); // Reset to first section when year changes
  };

  // Document management functions
  const addDocument = (itemId) => {
    setResponses((prev) => {
      const currentDocs = prev[itemId]?.documents || [];
      const existingAttachments = prev[itemId]?.existingAttachments || [];
      const totalAttachments = currentDocs.length + existingAttachments.length;

      if (totalAttachments >= 3) return prev; // Max 3 documents total

      return {
        ...prev,
        [itemId]: {
          ...(prev[itemId] || {}),
          documents: [
            ...currentDocs,
            { name: "", file: null, fileDetails: null, id: Date.now() },
          ],
        },
      };
    });
  };

  const removeDocument = (itemId, docId) => {
    setResponses((prev) => ({
      ...prev,
      [itemId]: {
        ...(prev[itemId] || {}),
        documents:
          prev[itemId]?.documents?.filter((doc) => doc.id !== docId) || [],
      },
    }));
  };

  const updateDocumentName = (itemId, docId, name) => {
    setResponses((prev) => ({
      ...prev,
      [itemId]: {
        ...(prev[itemId] || {}),
        documents:
          prev[itemId]?.documents?.map((doc) =>
            doc.id === docId ? { ...doc, name: name.slice(0, 255) } : doc,
          ) || [],
      },
    }));
  };

  const updateDocumentFile = (itemId, docId, file) => {
    if (!file) return;

    const fileDetails = {
      name: file.name,
      size: file.size,
    };

    setResponses((prev) => ({
      ...prev,
      [itemId]: {
        ...(prev[itemId] || {}),
        documents:
          prev[itemId]?.documents?.map((doc) =>
            doc.id === docId ? { ...doc, file, fileDetails } : doc,
          ) || [],
      },
    }));
  };

  const handleRadioChange = (itemId, value) => {
    setResponses((prev) => ({
      ...prev,
      [itemId]: { ...(prev[itemId] || {}), status: value },
    }));
  };

  const handleRemarksChange = (itemId, value) => {
    setResponses((prev) => ({
      ...prev,
      [itemId]: { ...(prev[itemId] || {}), remarks: value },
    }));
  };

  const handleInspectorChange = (itemId, value) => {
    setResponses((prev) => ({
      ...prev,
      [itemId]: { ...(prev[itemId] || {}), inspector: value },
    }));
  };

  const previousSection = () => {
    if (currentSection > 0) {
      setCurrentSection((prev) => prev - 1);
    }
  };

  const goToNextSection = () => {
    if (currentSection < form.sections.length - 1) {
      setCurrentSection((prev) => prev + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const goToSection = () => {
    if (!gotoValue.trim()) return;

    let val = gotoValue.trim();

    // Option A: take integer part only
    let sectionNum = parseInt(val.split(".")[0]);

    if (!sectionNum || sectionNum < 1 || sectionNum > form.sections.length) {
      setSeverity("error");
      setSnackbarMessage("Invalid section number.");
      setSnackbarOpen(true);
      return;
    }

    setCurrentSection(sectionNum - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isLastSection = () => {
    return currentSection === form.sections.length - 1;
  };

  const handleUploadButtonClick = (itemId, docId) => {
    const fileInput = document.getElementById(`file-input-${itemId}-${docId}`);
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleFileInputChange = (itemId, docId, e) => {
    const file = e.target.files[0];
    if (file) {
      updateDocumentFile(itemId, docId, file);
    }
    e.target.value = ""; // Allow reselect
  };

  const handleDeleteFile = async (
    itemId,
    attachmentId = null,
    attachmentName = "",
  ) => {
    if (attachmentId) {
      // Show confirmation popup for existing attachments
      setDeleteConfirmation({
        isOpen: true,
        itemId,
        attachmentId,
        attachmentName,
      });
    } else {
      // Direct delete for local files
      setSnackbarMessage("Local file removed");
      setSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => {
        setSnackbarOpen(false);
      }, 3000);
    }
  };

  const confirmDelete = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const { itemId, attachmentId } = deleteConfirmation;

      const response = await axios.delete(
        `${API_URL}/api/qc/attachments/${attachmentId}`,
        {
          headers: {
            Authorization: authKey,
          },
        },
      );

      if (response.status === 200) {
        setSeverity("success");
        setSnackbarMessage("Attachment deleted successfully");
        setSnackbarOpen(true);
        await fetchFormData(formId);
      }
    } catch (error) {
      console.error("Error deleting attachment:", error);
      setSeverity("error");
      setSnackbarMessage("Failed to delete attachment");
      setSnackbarOpen(true);
    }

    setDeleteConfirmation({
      isOpen: false,
      itemId: null,
      attachmentId: null,
      attachmentName: "",
    });

    setTimeout(() => {
      setSnackbarOpen(false);
    }, 3000);
  };

  const cancelDelete = () => {
    setDeleteConfirmation({
      isOpen: false,
      itemId: null,
      attachmentId: null,
      attachmentName: "",
    });
  };

  const handleDownloadAttachment = (attachmentId, filename) => {
    const authKey = localStorage.getItem("authKey");
    const downloadUrl = `${API_URL}/api/qc/attachments/${attachmentId}/download`;

    fetch(downloadUrl, {
      method: "GET",
      headers: {
        Authorization: authKey,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        setSeverity("error");
        setSnackbarMessage("Failed to download attachment");
        setSnackbarOpen(true);
      });
  };

  const handleViewAttachment = (attachmentId) => {
    const authKey = localStorage.getItem("authKey");
    const viewUrl = `${API_URL}/api/qc/attachments/${attachmentId}/view`;
    const newWindow = window.open("", "_blank");

    fetch(viewUrl, {
      method: "GET",
      headers: {
        Authorization: authKey,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Failed to load file");
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        newWindow.location.href = url;
      })
      .catch((error) => {
        console.error("View failed:", error);
        newWindow.close();
        setSeverity("error");
        setSnackbarMessage("Failed to view attachment");
        setSnackbarOpen(true);
      });
  };

  const handleSaveCurrentSection = async () => {
    const section = form.sections[currentSection];
    if (!section?.items) return;

    const sectionResponses = [];
    const formData = new FormData();

    section.items.forEach((item) => {
      const itemId = item.id || item.item_id;
      const itemData = responses[itemId];

      if (itemData?.status) {
        sectionResponses.push({
          item_id: itemId,
          rating: itemData.status,
          remarks: itemData.remarks || "",
          inspector: itemData.inspector || "",
        });

        // Handle multiple named documents
        if (itemData.documents && itemData.documents.length > 0) {
          itemData.documents.forEach((doc, index) => {
            if (doc.file && doc.name.trim()) {
              formData.append(
                `docs_${itemId}[${index}][name]`,
                doc.name.trim(),
              );
              formData.append(`docs_${itemId}[${index}][file]`, doc.file);
            }
          });
        }
      }
    });

    if (sectionResponses.length === 0) {
      alert("Please fill at least one item before saving this section.");
      return;
    }

    // Check for documents without names
    const hasInvalidDocs = sectionResponses.some((resp) => {
      const itemData = responses[resp.item_id];
      return itemData.documents?.some((doc) => doc.file && !doc.name.trim());
    });

    if (hasInvalidDocs) {
      setSeverity("error");
      setSnackbarMessage("Please provide names for all uploaded documents");
      setSnackbarOpen(true);
      return;
    }

    formData.append("responses", JSON.stringify(sectionResponses));

    if (selectedYear) {
      formData.append("cycle_year", selectedYear.toString());
    }

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await fetch(
        `${API_URL}/api/qc/forms/${formId}/submit-batch`,
        {
          method: "POST",
          headers: { Authorization: authKey },
          body: formData,
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      setSeverity("success");
      setSnackbarMessage("Section saved successfully");
      setSnackbarOpen(true);

      setTimeout(() => {
        setSnackbarOpen(false);
      }, 2500);

      setTimeout(async () => {
        await fetchFormData(formId);
        if (currentSection < form.sections.length - 1) {
          setCurrentSection((prev) => prev + 1);
        }
      }, 1500);
    } catch (err) {
      console.error("Error saving section:", err);
      setSeverity("error");
      setSnackbarMessage(`Failed to save section: ${err.message}`);
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const clickOnBackBtn = () => {
    navigate("/iqcm-form-list");
  };

  // Helper function to render attachments section
  const renderAttachmentsSection = (item, itemResponse) => {
    const itemId = item.id || item.item_id;
    const existingAttachments = itemResponse.existingAttachments || [];
    const documents = itemResponse.documents || [];
    const totalAttachments = existingAttachments.length + documents.length;

    return (
      <div className="field">
        <label className="field-label">Attachments</label>

        {/* Attachment Guidelines */}
        <div className="attachment-guidelines">
          <div className="guidelines-content">
            <span className="guidelines-text">
              Maximum 3 files allowed • Maximum file size: 5 MB per file
            </span>
            <span className="supported-formats">
              Supported formats: Images, PDF, DOC, DOCX
            </span>
          </div>
        </div>

        {/* Existing attachments */}
        {existingAttachments.map((attachment) => {
          if (attachment.popupOpen === undefined) attachment.popupOpen = false;

          return (
            <div key={attachment.id} className="existing-attachment-row">
              <div className="attachment-content">
                <input
                  type="text"
                  value={attachment.doc_name || ""}
                  placeholder="Document name"
                  readOnly
                  className="attachment-name-input"
                />
                <div className="attachment-actions">
                  <button
                    type="button"
                    className="attachment-open-btn"
                    onClick={() =>
                      setResponses((prev) => ({
                        ...prev,
                        [itemId]: {
                          ...(prev[itemId] || {}),
                          existingAttachments: prev[
                            itemId
                          ]?.existingAttachments.map((att) =>
                            att.id === attachment.id
                              ? { ...att, popupOpen: !att.popupOpen }
                              : att,
                          ),
                        },
                      }))
                    }
                  >
                    <MdAttachFile />
                  </button>
                </div>
              </div>

              {/* Popup for existing attachments */}
              {attachment.popupOpen && (
                <div className="attachment-popup-backdrop">
                  <div className="attachment-popup">
                    <div className="attachment-popup-content">
                      <div className="attachment-popup-header">
                        <div className="attachment-popup-title">
                          {attachment.doc_name || "Attachment"}
                        </div>
                        <button
                          className="popup-close-btn"
                          onClick={() =>
                            setResponses((prev) => ({
                              ...prev,
                              [itemId]: {
                                ...(prev[itemId] || {}),
                                existingAttachments: prev[
                                  itemId
                                ]?.existingAttachments.map((att) =>
                                  att.id === attachment.id
                                    ? { ...att, popupOpen: false }
                                    : att,
                                ),
                              },
                            }))
                          }
                        >
                          <IoCloseOutline />
                        </button>
                      </div>
                      <div className="attachment-popup-body">
                        <div className="attachment-file-info">
                          <div className="file-info-row">
                            <strong>File Name:</strong> {attachment.filename}
                          </div>
                          <div className="file-info-row">
                            <strong>Size:</strong>{" "}
                            {(attachment.file_size / 1024).toFixed(2)} KB
                          </div>
                        </div>
                        <div className="attachment-popup-actions">
                          <button
                            onClick={() =>
                              handleDownloadAttachment(
                                attachment.id,
                                attachment.filename,
                              )
                            }
                            className="popup-action-btn download-btn"
                          >
                            Download
                          </button>
                          <button
                            onClick={() => handleViewAttachment(attachment.id)}
                            className="popup-action-btn view-btn"
                          >
                            View
                          </button>
                          <button
                            className="popup-action-btn delete-btn"
                            onClick={() =>
                              handleDeleteFile(
                                itemId,
                                attachment.id,
                                attachment.doc_name || attachment.filename,
                              )
                            }
                          >
                            <MdDeleteOutline />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* New documents */}
        {documents.map((doc, index) => {
          if (doc.popupOpen === undefined) doc.popupOpen = false;
          const hasFile = !!doc.fileDetails;

          return (
            <div key={doc.id} className="new-attachment-row">
              <div className="new-attachment-content">
                <input
                  type="text"
                  value={doc.name}
                  placeholder={`Document ${index + 1} name *`}
                  onChange={(e) =>
                    updateDocumentName(itemId, doc.id, e.target.value)
                  }
                  className="attachment-name-input"
                  maxLength={255}
                  required={!!doc.file}
                />

                <div className="new-attachment-actions">
                  <button
                    type="button"
                    onClick={() => handleUploadButtonClick(itemId, doc.id)}
                    className="upload-file-btn"
                  >
                    <FiUpload /> Choose File
                  </button>

                  {hasFile && (
                    <button
                      type="button"
                      onClick={() =>
                        setResponses((prev) => ({
                          ...prev,
                          [itemId]: {
                            ...(prev[itemId] || {}),
                            documents: prev[itemId]?.documents.map((d) =>
                              d.id === doc.id
                                ? { ...d, popupOpen: !d.popupOpen }
                                : d,
                            ),
                          },
                        }))
                      }
                      className="attachment-open-btn"
                    >
                      <MdAttachFile />
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => removeDocument(itemId, doc.id)}
                    className="remove-attachment-btn"
                  >
                    <MdDeleteOutline />
                  </button>
                </div>
              </div>

              <input
                id={`file-input-${itemId}-${doc.id}`}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleFileInputChange(itemId, doc.id, e)}
                accept="image/*,.pdf,.doc,.docx"
              />

              {/* Popup for new docs */}
              {doc.popupOpen && hasFile && (
                <div className="attachment-popup-backdrop">
                  <div className="attachment-popup">
                    <div className="attachment-popup-content">
                      <div className="attachment-popup-header">
                        <div className="attachment-popup-title">
                          {doc.name || "New Attachment"}
                        </div>
                        <button
                          className="popup-close-btn"
                          onClick={() =>
                            setResponses((prev) => ({
                              ...prev,
                              [itemId]: {
                                ...(prev[itemId] || {}),
                                documents: prev[itemId]?.documents.map((d) =>
                                  d.id === doc.id
                                    ? { ...d, popupOpen: false }
                                    : d,
                                ),
                              },
                            }))
                          }
                        >
                          <IoCloseOutline />
                        </button>
                      </div>
                      <div className="attachment-popup-body">
                        <div className="attachment-file-info">
                          <div className="file-info-row">
                            <strong>File Name:</strong> {doc.fileDetails.name}
                          </div>
                          <div className="file-info-row">
                            <strong>Size:</strong>{" "}
                            {(doc.fileDetails.size / 1024).toFixed(2)} KB
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* Add Document Button */}
        <div className="add-attachment-section">
          <button
            type="button"
            onClick={() => addDocument(itemId)}
            disabled={totalAttachments >= 3}
            className="add-attachment-btn"
          >
            <FaPlusCircle />
            <span>Add Document</span>
          </button>
          <span className="attachment-counter">({totalAttachments}/3)</span>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="iqcm-container">
        <div className="loading">Loading form data...</div>
      </div>
    );
  }

  if (error && !form) {
    return (
      <div className="iqcm-container">
        <div className="error-container">
          <div className="error-text">{error}</div>
          <button onClick={() => fetchFormData(formId)} className="retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!form || !form.sections || form.sections.length === 0) {
    return (
      <div className="iqcm-container">
        <div className="no-data">No form data available.</div>
      </div>
    );
  }

  const currentSectionData = form.sections[currentSection];

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="form-wrapper">
          {/* Form Header */}
          <div className="form-header">
            <div className="qc_form_title_div">
            <button onClick={clickOnBackBtn} className="circle-back-btn">
              <FiArrowLeft size={20} />
            </button>
            <h2 className="form-title">{form.name}</h2>
            </div>
            <div>
              <p className="form-meta">Created at: {form.created_at}</p>
              <p className="form-meta">
                Last updated at: {allResponseData?.last_updated_at}
              </p>
              <p className="form-meta">
                Progress: {progress.completed_sections}/
                {progress.total_sections} sections (
                {progress.completion_percentage.toFixed(1)}%)
              </p>

              {/* Year Dropdown */}
              <div className="qc_form_dropdown_year_container">
                <label className="qc_form_dropdown_year_label">Year:</label>
                <select
                  value={selectedYear || ""}
                  onChange={handleYearChange}
                  className="qc_form_dropdown_year_select"
                >
                  {availableYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Section Title */}
          <h3 className="section-title">
            Section : {currentSectionData?.section_code}.{" "}
            {currentSectionData.section_title}
          </h3>

          {/* Error Message */}
          {error && <div className="error-message">{error}</div>}

          {/* Items List */}
          <div className="items-list">
            {currentSectionData.items.map((item, index) => {
              const itemId = item.id || item.item_id;
              const itemResponse = responses[itemId] || {};

              return (
                <div key={itemId} className="item-card">
                  <span>
                    <p className="item-prompt">
                      <strong>{item.question_code} </strong>. {item.prompt}
                    </p>
                  </span>

                  {/* Rating */}
                  <div className="field">
                    <div className="radio-group-wrapper">
                      <div className="radio-group">
                        {[
                          { value: "NYS", label: "NYS" },
                          { value: "FM", label: "FM" },
                          { value: "PM", label: "PM" },
                          { value: "NC", label: "NC" },
                          { value: "NA", label: "NA" },
                        ].map((option) => (
                          <label key={option.value} className="radio-option">
                            <input
                              type="radio"
                              name={`item-${itemId}`}
                              value={option.value}
                              checked={itemResponse.status === option.value}
                              onChange={() =>
                                handleRadioChange(itemId, option.value)
                              }
                            />
                            <span className="radio-text">{option.label}</span>
                          </label>
                        ))}
                      </div>

                      <div className="iqcm-info-icon">
                        <FiInfo size={18} />
                        <div className="iqcm-tooltip">
                          <p>
                            <strong>NYS</strong> – Not Yet Started
                          </p>
                          <p>
                            <strong>FM</strong> – Fully Met
                          </p>
                          <p>
                            <strong>PM</strong> – Partially Met
                          </p>
                          <p>
                            <strong>NC</strong> – Not Complied
                          </p>
                          <p>
                            <strong>NA</strong> – Not Applicable
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Remarks */}
                  <div className="field">
                    <label className="field-label">Remarks</label>
                    <textarea
                      value={itemResponse.remarks || ""}
                      onChange={(e) =>
                        handleRemarksChange(itemId, e.target.value)
                      }
                      className="textarea"
                      placeholder="Add any remarks or observations"
                      rows="2"
                    />
                  </div>

                  {/* Attachments - Use the updated render function */}
                  {renderAttachmentsSection(item, itemResponse)}
                </div>
              );
            })}
          </div>

          {/* Navigation Buttons */}
          <div className="navigation-container">
            <div className="nav-buttons">
              <div className="next_save_btn">
                <button
                  type="button"
                  onClick={previousSection}
                  disabled={currentSection === 0}
                  className="nav-btn data-form-cancel-button"
                >
                  Previous
                </button>
              </div>

              <div className="next_save_btn">
                {isLastSection() ? (
                  <>
                    <button
                      type="button"
                      onClick={goToNextSection}
                      disabled={currentSection === form.sections.length - 1}
                      className="nav-btn data-form-cancel-button"
                    >
                      Next
                    </button>
                    <button
                      type="button"
                      onClick={handleSaveCurrentSection}
                      className="nav-btn next-btn data-form-save-button"
                    >
                      Save Final Section
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={goToNextSection}
                      disabled={currentSection === form.sections.length - 1}
                      className="nav-btn data-form-cancel-button"
                    >
                      Next
                    </button>
                    <button
                      type="button"
                      onClick={handleSaveCurrentSection}
                      className="nav-btn next-btn data-form-save-button"
                    >
                      Save & Next
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Popup */}
      {deleteConfirmation.isOpen && (
        <div className="attachment-popup-backdrop">
          <div className="delete-confirmation-popup">
            <div className="delete-confirmation-content">
              <div className="delete-confirmation-header">
                <div className="delete-confirmation-title">Confirm Delete</div>
              </div>
              <div className="delete-confirmation-body">
                <div className="delete-warning-icon"></div>
                <div className="delete-confirmation-text">
                  ⚠️ Are you sure you want to permanently delete this
                  attachment?
                </div>
                <div className="delete-file-name">
                  "{deleteConfirmation.attachmentName}"
                </div>
                <div className="delete-warning-text">
                  This action cannot be undone.
                </div>
              </div>
              <div className="delete-confirmation-actions">
                <button className="delete-cancel-btn" onClick={cancelDelete}>
                  Cancel
                </button>
                <button className="delete-confirm-btn" onClick={confirmDelete}>
                  Delete Permanently
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default IqcmFormView;
